    <!-- Page Title -->
<div class="page-title dark-background" style="background-image: url(assets/img/image9.jpg);">
    <div class="container position-relative">
      <h1>{{title}}</h1>
      <nav class="breadcrumbs">
        <ol>
          <li><a style="color: var(--accent-color);" routerLink="/Home">Startseite</a></li>
          <li class="current">{{title}}</li>
        </ol>
      </nav>
    </div>
</div><!-- End Page Title -->